export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-play-video-0db7d23e0e549fa328e4102a9ceceaa2.svg";